import React from "react";
import { Helmet } from "react-helmet-async";
import FAQSchemaGenerator from "./FAQSchemaGenerator";
function MetaTags() {
	const origin = window.location.origin;

	return (
		<Helmet>
			{/* Title Tag */}
			<title>Innovative Full Stack Developer | Murtaza Lightwala</title>

			{/* Meta Description */}
			<meta
				name="description"
				content="Discover how Team Lead and Senior Software Engineer, Murtaza Lightwala, transforms ideas into reality with over 4.6 years of experience in Node.js, React.js, AI-powered innovations, and more."
			/>

			{/* Meta Keywords */}
			<meta
				name="keywords"
				content="Murtaza Lightwala, Full Stack Developer, Senior Software Engineer, Team Lead, Node.js, React.js, AI, Machine Learning, Software Development, Indore, India"
			/>

			{/* Canonical Link */}
			<link rel="canonical" href={origin} />

			{/* Open Graph Meta Tags */}
			<meta
				property="og:title"
				content="Innovative Full Stack Developer | Murtaza Lightwala"
			/>
			<meta
				property="og:description"
				content="Join Senior Software Engineer and Team Lead, Murtaza Lightwala, in propelling innovation at light speed with over 4.6 years of experience in Node.js, React.js, and AI-powered solutions."
			/>
			<meta
				property="og:image"
				content={`${origin}/assets/images/profile/murtaza-lightwala-headshot.webp`}
			/>
			<meta property="og:url" content={origin} />
			<meta property="og:type" content="website" />

			{/* Twitter Card Meta Tags */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta
				name="twitter:title"
				content="Innovative Full Stack Developer | Murtaza Lightwala"
			/>
			<meta
				name="twitter:description"
				content="Transforming ideas into reality with over 4.6 years of experience in Node.js, React.js, and AI solutions. Connect with Senior Software Engineer and Team Lead, Murtaza Lightwala."
			/>
			<meta
				name="twitter:image"
				content={`${origin}/assets/images/profile/murtaza-lightwala-headshot.webp`}
			/>
			<meta name="twitter:site" content="@rationalmurtaza" />

			{/* Viewport Meta Tag */}
			<meta name="viewport" content="width=device-width, initial-scale=1" />

			{/* Robots Meta Tag */}
			<meta name="robots" content="index, follow" />

			{/* Charset Meta Tag */}
			<meta charSet="UTF-8" />

			{/* Author Meta Tag */}
			<meta name="author" content="Murtaza Lightwala" />

			{/* Alternate Language Tags (if applicable) */}
			{/* <link rel="alternate" hrefLang="en" href="https://www.yoursite.com/en/" /> */}
			{/* <link rel="alternate" hrefLang="hi" href="https://www.yoursite.com/hi/" /> */}

			{/* Structured Data Markup (JSON-LD) */}
			<script type="application/ld+json">
				{JSON.stringify({
					"@context": "http://www.schema.org",
					"@type": "person",
					name: "Murtaza Lightwala",
					jobTitle: "Team Lead",
					gender: "male",
					url: `${origin}`,
					sameAs: [
						"https://x.com/rationalmurtaza",
						"https://www.linkedin.com/in/techmurtaza/",
						"https://github.com/techmurtaza",
						"https://www.instagram.com/rationalmurtaza",
						"https://www.facebook.com/rationalmurtaza/",
					],
					image:
						`${origin}/assets/images/profile/murtaza-lightwala-headshot.webp`,
					address: {
						"@type": "PostalAddress",
						addressLocality: "Indore",
						addressRegion: "Madhya Pradesh",
						postalCode: "452012",
						addressCountry: "India",
					},
					email: "lightwalamurtaza5210@gmail.com",
					birthDate: "1995-05-24",
					alumniOf: "NIT Raipur",
					birthPlace: "INDORE",
					nationality: "Indian",
					telephone: "+919755565810",
				})}
			</script>
			
			{/* FAQPage Schema Markup */}
			<script type="application/ld+json">
				{JSON.stringify(FAQSchemaGenerator({ slug: "index" }))}
			</script>
		</Helmet>
	);
}

export default MetaTags;
